import React, { useState, useEffect, useRef } from "react";
import { Row, Card } from "react-bootstrap";

function AccordionItem({ card, isOpen, onToggle, index }) {
    const contentRef = useRef(null);

    useEffect(() => {
        const el = contentRef.current;
        if (!el) return;
        el.style.maxHeight = isOpen ? `${el.scrollHeight}px` : "0";
    }, [isOpen]);

    return (
        <Row
            className={`m-0 p-0 ${index !== 0 ? "mt-4" : ""}`}
            onClick={onToggle}
        >
            <Card
                className="text-white border-0 p-0"
                style={{
                    background: "var(--newGray)", // <-- fixed missing ")"
                    borderBottomLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                }}
            >
                <Card.Img variant="top" src={card?.imgSrc?.file} />
                <Card.Body className="pt-2 pb-0 text-center">
                    <Card.Title style={{ fontSize: "15px", fontWeight: "unset" }}>
                        {card?.titleSwe}
                        <br />
                        {isOpen ? (
                            <i className="fa fa-angle-up mt-1" />
                        ) : (
                            <i className="fa fa-angle-down mt-1" />
                        )}
                    </Card.Title>
                    <div
                        id={`content-${index}`}
                        ref={contentRef}
                        className={`cardTextContent ct-${index}`}
                    >
                        {card?.contentSwe}
                        <div className="mb-3" />
                    </div>
                </Card.Body>
            </Card>
        </Row>
    );
}

export default function CardAccordion({ content = [] }) {
    const [openIndex, setOpenIndex] = useState(null);

    return (
        <>
            {content.map(({ card }, index) => (
                <AccordionItem
                    key={card?.id ?? index} // stable key preferred
                    card={card}
                    index={index}
                    isOpen={openIndex === index}
                    onToggle={() => setOpenIndex(openIndex === index ? null : index)}
                />
            ))}
        </>
    );
}
